<script setup lang="ts">
import EdgeFinder from '@/components/atoms/swade/EdgeFinder.vue';
import { useUxData } from '@/stores/ux-data';
import type { AppliedConfiguration, SwadeEdgeInterface, SwadeModificationInterface } from '@/types/items';
import type { WorldInterface } from '@/types/worlds';

const props = defineProps<{
  source: { uuid: string, name: string },
  originalMod: SwadeModificationInterface,
  world: WorldInterface | null,
  existing?: AppliedConfiguration | null,
}>();

const emit = defineEmits<{
  confirmed: [applied: AppliedConfiguration],
  cancelled: [],
}>();

const ux = useUxData();

// Convert the EdgeFinder selection into the AppliedConfiguration shape that the dispatch
// expects for character.edges adds. Operator is 'add' so applyModification routes to
// applyEdgeModification → addEdgeToCharacter (full cascade: container created, edge's own
// modifications applied, protoData entry pushed).
const onEdgeSelected = (event: { item: SwadeEdgeInterface, value: string }) => {
  if (!event.item) return;

  emit('confirmed', {
    uuid: props.source.uuid,
    choiceSetUuid: props.originalMod.uuid,
    configuration: {
      path: 'character.edges',
      element: event.item.uuid,
      label: event.item.name,
      value: null,
      valueType: null,
      operator: 'add',
      mod_type: 'character',
      summary: null,
    },
  });
};
</script>

<template>
  <div class="edge-picker">
    <div class="edge-picker-prompt mb-3">
      {{ originalMod?.configuration?.label
          ?? ux.labels?.swade?.data?.edges?.actions?.pick
          ?? 'Pick an Edge' }}
    </div>

    <EdgeFinder
        :placeholder="ux.labels?.swade?.data?.edges?.actions?.add ?? 'Add an Edge'"
        :browsable="true"
        placement="bottom"
        :filters="{ world }"
        @edge-selected="onEdgeSelected"
    />

    <div class="edge-picker-footer text-end mt-3">
      <button type="button" class="btn btn-secondary"
              data-action="cancel"
              @click="emit('cancelled')">
        {{ ux.labels?.actions?.cancel ?? 'Cancel' }}
      </button>
    </div>
  </div>
</template>
